<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.66797 10.0013C1.66797 6.07293 1.66797 4.10874 2.88836 2.88836C4.10874 1.66797 6.07293 1.66797 10.0013 1.66797C13.9296 1.66797 15.8939 1.66797 17.1142 2.88836C18.3346 4.10874 18.3346 6.07293 18.3346 10.0013C18.3346 13.9296 18.3346 15.8939 17.1142 17.1142C15.8939 18.3346 13.9296 18.3346 10.0013 18.3346C6.07293 18.3346 4.10874 18.3346 2.88836 17.1142C1.66797 15.8939 1.66797 13.9296 1.66797 10.0013ZM4.16797 7.08449V6.2513C4.16797 5.56094 4.72761 5.0013 5.41797 5.0013H14.5846C15.275 5.0013 15.8346 5.56094 15.8346 6.2513V7.08449C15.4865 6.82294 15.0536 6.66797 14.5846 6.66797H5.41797C4.94897 6.66797 4.51616 6.82294 4.16797 7.08449ZM4.16797 8.7513V9.58447C4.51616 9.32297 4.94897 9.16797 5.41797 9.16797H14.5846C15.0536 9.16797 15.4865 9.32297 15.8346 9.58447V8.7513C15.8346 8.06094 15.275 7.5013 14.5846 7.5013H5.41797C4.72761 7.5013 4.16797 8.06094 4.16797 8.7513ZM16.668 11.8765C17.0131 11.8765 17.293 12.1562 17.293 12.5015C17.293 12.8466 17.0131 13.1265 16.668 13.1265H14.7154C13.9831 13.1265 13.7911 13.1375 13.6264 13.2057C13.4616 13.274 13.3181 13.4019 12.8003 13.9197L12.5466 14.1735C12.1866 14.5341 11.9022 14.8189 11.5402 14.99C11.4728 15.0219 11.4038 15.0505 11.3336 15.0756C10.9566 15.2106 10.5541 15.2102 10.0446 15.2098H9.95647H9.86297C9.32438 15.2103 8.89889 15.2106 8.50422 15.0611C8.43072 15.0333 8.35872 15.0017 8.28849 14.9665C7.91123 14.7772 7.62342 14.4639 7.25911 14.0671L7.16634 13.9662C6.67606 13.4333 6.53925 13.3006 6.38054 13.2258C6.36374 13.2179 6.34672 13.2104 6.32952 13.2034C6.16703 13.1372 5.97667 13.1265 5.25253 13.1265H3.33464C2.98946 13.1265 2.70964 12.8466 2.70964 12.5015C2.70964 12.1562 2.98946 11.8765 3.33464 11.8765L4.18506 11.8764V11.0432C4.28413 10.4519 4.79835 10.0013 5.41783 10.0013H14.5845C15.204 10.0013 15.7182 10.4519 15.8172 11.0432V11.8764L16.668 11.8765Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'LegalIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>